import React, { useState, useEffect } from 'react';
import './ViewPageProject.css';
import { Text, Grid, TextField, Button, Icon, Alert, useTheme, ScrollView, Table, TableHead, TableCell, TableRow, TableBody } from '@aws-amplify/ui-react';
import { MdEdit, MdDeleteOutline, MdClose, MdOutlineRemoveCircleOutline } from 'react-icons/md';
import UpdateProjectForm from './UpdateProjectForm';
import ConfirmView from '../commons/ConfirmView';
import { Loader } from '@aws-amplify/ui-react';
import { deleteProject, deleteUserProject } from '../graphql/mutations';
import { generateClient } from 'aws-amplify/api';
import { listUserProjects } from '../graphql/queries';

const client = generateClient();

const ViewPageProject = ({ selectProject, onCancel }) => {
    const [name, setName] = useState('');
    const [path, setPath] = useState('');
    // const [metadata, setMetadata] = useState(false);
    const [metadataValue, setMetadataValue] = useState('');
    const [isSuccessOpen, setisSuccessOpen] = useState(false);
    const [isView, setIsView] = useState(true);
    const [project, setProject] = useState({});
    const [isDelete, setIsDelete] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isTemporal, setIsTemporal] = useState(true);
    const [temporalComponent, setTemporalComponent] = useState();
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [userProjectList, SetUserProjectList] = useState([]);
    const [selectRemoveUser, setSelectRemoveUser] = useState({});
    const [isConfirmPopUp, setIsConfirmPopUp] = useState(false);

    const { tokens } = useTheme();

    const handlerError = (message) => {
        setIsDelete(false);
        setErrorMessage(message);
        setIsError(true);
    }

    const handlerLoader = () => {
        setTimeout(() => {
            setIsTemporal(false);
        }, 1000);

        setTemporalComponent(
            <Loader
                variation="linear"
                emptyColor={tokens.colors.gray}
                filledColor={'#588292'}
            />)
    }

    const handlerMessage = () => {
        // setisError(true);
        setIsTemporal(true);
        setTimeout(() => {
            // setisError(false);
            setIsTemporal(false)
        }, 3000);
        setTemporalComponent(<><br />
            <Alert
                variation="success"
                heading="Eliminado Correctamente"
                height='50px'
                size={'large'}
                marginTop={'-3rem'}
            ></Alert>

            <br /></>)

    };

    const handlerTemporal = (type) => {
        if (type === 'message') {
            handlerMessage();
        }
        if (type === 'loader') {
            handlerLoader();
        }
    }

    useEffect(() => {
        setProject(selectProject);
        setName(selectProject.name);
        setPath(selectProject.path);
        // setMetadata(selectProject.metadata);

        const fetchUserProjectsList = async () => {
            try {
                const userProjectList = await getListUserProjects(selectProject.id);
                const items = userProjectList['data']['listUserProjects']['items'];
                SetUserProjectList(items);
            } catch (error) {
                console.error('Error fetching userProjectList: ', error);
            }
        };

        fetchUserProjectsList();

        if (selectProject.metadata) {
            setMetadataValue("Sí");
        } else {
            setMetadataValue("No");
        }
    }, []);

    const handlersOnCancel = () => {
        onCancel();
    }

    const handleSubmit = (projectData) => {
        setName(projectData.name);
        setPath(projectData.path);
        // setMetadata(projectData.metadata);
        if (projectData.metadata) {
            setMetadataValue("Sí");
        } else {
            setMetadataValue("No");
        }
        setProject(projectData);

        setTimeout(() => {
            setisSuccessOpen(false);
        }, 5000);

        setisSuccessOpen(true);
        setIsView(true);
    };

    const closeEditView = async () => {
        setIsView(true);
        setIsUpdate(false);
    };

    const handlerClickOnEdit = async () => {
        setIsView(false);
        setIsUpdate(true);
    };

    const handleDeleteProject = async () => {
        setIsView(false);
        setIsDelete(true);
    };

    const handlerCancelRemoveProject = async () => {
        setIsView(true);
        setIsDelete(false);
    };

    const getListUserProjects = async (projectId) => {
        try {
            const response = await client.graphql({
                query: listUserProjects,
                variables: {
                    filter: {
                        projectId: {eq: projectId}
                    }
                }

            });
            return response;
        } catch (e) {
            console.log('Error in userProjects Query', e);
            return [];
        }

    }

    const handlerConfirmRemoveProject = async () => {

        try {

            for (let item of userProjectList) {
                await client.graphql({
                    query: deleteUserProject,
                    variables: {
                        input: {
                            id: item.id
                        }
                    }
                });
            }

            const responseDeleteProject = await client.graphql({
                query: deleteProject,
                variables: {
                    input: {
                        id: selectProject.id
                    }
                }
            });
            setIsDelete(false);
            setIsView(true);
            handlerTemporal('message');

            setTimeout(() => {
                handlersOnCancel();
            }, 3000);

            console.log('Project removed Success');
            return responseDeleteProject;
        } catch (e) {
            const message = 'No se ha podido remover el proyecto'
            handlerError(message);
            console.log('Error in remove project by user', e);
            return [];
        }

    }

    const handlerConfirmRemoveUserFromProject = async () => {
        try {
            const response = await client.graphql({
                query: deleteUserProject,
                variables: {
                    input: {
                        id: selectRemoveUser.id
                    }
                }
            });
            setIsConfirmPopUp(false);
            handlerTemporal('message');
            console.log('User project remove Success');
            return response;
        } catch (e) {
            const message = 'No se ha podido remover el proyecto'
            handlerError(message);
            console.log('Error in remove project by user', e);
            return [];
        }

    }

    useEffect(() => {
        handlerTemporal("loader");
    }, [selectProject]);

    useEffect(() => {
        handlerTemporal("loader");
    }, [selectRemoveUser]);

    const handlerRemoveUser = async (user) => {
        setSelectRemoveUser(user);
        setIsConfirmPopUp(true);
    }

    const handlerCancelRemoveUser = async () => {
        setIsConfirmPopUp(false);
    }

    return (
        <>
            {isView ? (
                <>
                    {isSuccessOpen && <><Alert
                        variation="success"
                        heading="Proyecto actualizado correctamente"
                        isDismissible
                    ></Alert><br /></>}
                    <Grid
                        templateColumns="5fr 1fr"
                        templateRows="2rem"
                    >
                        <Button
                            variation="primary"
                            colorTheme="success"
                            onClick={handlersOnCancel}
                            className='button-back'
                        >
                            <Icon
                                as={MdClose} aria-hidden="true"
                            />
                        </Button>
                        <Grid
                            templateColumns="10fr 1fr"
                            templateRows="2rem">
                            <Button
                                variation="primary"
                                colorTheme="success"
                                onClick={handlerClickOnEdit}
                                className='button-back'
                            >
                                <Icon as={MdEdit} aria-hidden="true" />
                            </Button>
                            <Button
                                variation="primary"
                                colorTheme="success"
                                onClick={handleDeleteProject}
                                className='button-back'
                            >
                                <Icon as={MdDeleteOutline} aria-hidden="true" />
                            </Button>
                        </Grid>
                    </Grid>
                    {isTemporal ? (
                        <Grid
                            templateColumns="10fr"
                            templateRows="12rem"
                        >
                            <div>

                            </div>
                            {/* <Loader
                                variation="linear"
                                emptyColor={tokens.colors.gray}
                                filledColor={'#588292'}
                            /> */}
                            {temporalComponent}
                        </Grid>
                    ) :
                        (
                            <>

                                <Grid
                                    templateColumns="6fr 1fr"
                                    templateRows="4rem"
                                >
                                                                    <div className='div-text'>
                                    <Text className="labels-titles">Ruta del proyecto</Text>
                                    <TextField className='values'
                                        defaultValue={path}
                                        isReadOnly={true}
                                        size="small"
                                        variation="quiet"
                                    />
                                </div>
                                    <div className='div-text'>
                                        <Text className="labels-titles">¿Requiere medatada?</Text>
                                        <Text className="values">{metadataValue}</Text>
                                    </div>

                                </Grid>
                                <div className='div-text'>
                                        <Text className="labels-titles">Nombre</Text>
                                        {/* <Text className="values">{name}</Text> */}
                                        <TextField className='values'
                                        defaultValue={name}
                                        isReadOnly={true}
                                        size="small"
                                        variation="quiet"
                                    />

                                    </div>


                                {/* <Grid
                                    templateColumns="1fr 1fr"
                                    templateRows="3rem 3rem"
                                > */}
                                {(isConfirmPopUp) ? (
                                        <>
                                            <ConfirmView
                                                name={"setSelectRemoveUser.user.username"}
                                                handlerCancel={handlerCancelRemoveUser}
                                                handlerConfirm={handlerConfirmRemoveUserFromProject}
                                                type={'userFromProject'}
                                            />
                                        </>) : (<>
                                            <div className='div-text'>
                                        <Text className="labels-titles-users">Usuarios con acceso</Text>
                                        <div className='div-text'>
                                            {userProjectList.length > 0 ? (
                                                <>
                                                    <ScrollView height="136px" width="450px" maxWidth="100%">
                                                        <Table
                                                            caption=""
                                                            highlightOnHover={false}
                                                            size="small"
                                                            variation="striped"
                                                            className='table-projects-in-user'>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell as="th" colSpan="3">Username</TableCell>
                                                                    <TableCell as="th">Quitar</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {userProjectList.map((obj, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell
                                                                            colSpan="3"
                                                                        >{obj.user.username}</TableCell>
                                                                        <TableCell
                                                                            >
                                                                                <Button
                                                                                    variation="primary"
                                                                                    colorTheme="warning"
                                                                                    // onClick={handleuserPageToForm}
                                                                                    className='button-table'
                                                                                    title='Remover Proyecto a este usuario'
                                                                                    onClick={() => handlerRemoveUser(obj)}
                                                                                >
                                                                                    <Icon
                                                                                        viewBox={{ width: 20, height: 20 }}
                                                                                        color="red"
                                                                                        as={MdOutlineRemoveCircleOutline} aria-hidden="true"
                                                                                    />
                                                                                </Button>

                                                                            </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </ScrollView>
                                                </>) : (
                                                <Text
                                                    textAlign={'center'}
                                                    color='#901414ed'>
                                                    Este proyecto no
                                                    tiene usuarios asignados
                                                </Text>)}

                                        </div>
                                    </div>
                                        </>
                                        )}

                                    {/* <div className='div-text'>
                <Text className="labels-titles">Mapeo de datos</Text>

            </div> */}

                                {/* </Grid> */}
                            </>
                        )}
                </>
            ) : (
                <>
                    {isDelete &&
                        <>
                            <ConfirmView
                                projectName={selectProject.name}
                                handlerCancel={handlerCancelRemoveProject}
                                handlerConfirm={handlerConfirmRemoveProject}
                                type={'project'}
                            />
                        </>
                    }
                    {isUpdate &&
                        <>
                            <UpdateProjectForm
                                selectProject={project}
                                onCancel={closeEditView}
                                onUpdate={handleSubmit}
                            />
                        </>
                    }

                </>
            )}
            {isError &&
                <Alert
                    variation="error"
                    heading={errorMessage}
                    height='3rem'
                    isDismissible
                    marginBottom={'1rem'}
                    marginLeft={'1.7rem'}
                ></Alert>}

        </>
    );
};

export default ViewPageProject;
